<template>
  <article class="flex h-full flex-col gap-4 rounded-3xl border border-text-main/10 bg-white p-8 transition-shadow hover:shadow-[0_24px_60px_-30px_rgba(24,22,16,0.35)]">
    <div class="flex size-12 items-center justify-center rounded-2xl bg-primary/15 text-primary">
      <span class="material-symbols-outlined">{{ icon }}</span>
    </div>
    <div class="flex flex-col gap-2">
      <h3 class="text-text-main text-xl font-bold">{{ title }}</h3>
      <p class="text-text-muted">{{ text }}</p>
    </div>
  </article>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
  text: string;
}>();
</script>
